import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProcessoPlanejamento } from '../classes/ProcessoPlanejamento';


@Injectable({
  providedIn: 'root'
})
export class ProcessoPlanejamentoService {

  constructor(private http: HttpClient) { }

  private processosCache$: Observable<any> | null = null;
  getProcessosPlanejamento(): Observable<any>{
    if (!this.processosCache$) {
      this.processosCache$ = this.http.get(`${environment.apiURL}/processoPlanejamento`).pipe(shareReplay(1));
    }
    return this.processosCache$;
  }

  getProcessoPlanejamento(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/processoPlanejamento/${id}`)
  }

  postProcessoPlanejamento(processoPlanejamento: ProcessoPlanejamento): Observable<any>{
    this.processosCache$ = null;
    return this.http.post(`${environment.apiURL}/processoPlanejamento`, processoPlanejamento);
  }

  putProcessoPlanejamento(id: number, processoPlanejamento: ProcessoPlanejamento): Observable<any>{
    this.processosCache$ = null;
    return this.http.put(`${environment.apiURL}/processoPlanejamento/${id}`, processoPlanejamento);
  }

  deleteProcessoPlanejamento(id: number): Observable<any>{
    this.processosCache$ = null;
    return this.http.delete(`${environment.apiURL}/processoPlanejamento/${id}`);
  }
}
